export {
  // used: packages/bank-onboarding/src/routes.ts
  ApplicationEditRoute,
  // used: apps/client-portal/src/application/Application/router.tsx
  routeClientApplicationEdit
} from './routes/EditApplication'
